<template>
  <div class="container">
    <div class="login-canvas">
      <div class="col-md-6 d-md-flex align-items-md-center">
        <img
          class="img-fluid w-100 img-visibility"
          :src="heroImageSrc"
          alt=""
        />
      </div>
      <div class="login-canvas">
        <div class="login-panel pos-glass-elevated">
          <div class="text-center mb-4">
            <h2 class="akkurate-dark fw-bold mb-1">AKKURATE POS</h2>
            <p class="text-muted mb-0">Retail</p>
          </div>

          <b-alert v-model="showError" variant="danger" dismissible>
            {{ errorMsg }}
          </b-alert>

          <b-form @submit.prevent="onSubmit">
            <b-form-group label="Email" label-for="email">
              <b-form-input
                class="form-control"
                id="email"
                v-model="form.email"
                type="email"
                required
                placeholder="admin@akkuratepos.com"
              />
            </b-form-group>

            <b-form-group label="Password" label-for="password">
              <b-form-input
                class="form-control"
                id="password"
                v-model="form.password"
                type="password"
                required
                placeholder="Enter password"
              />
            </b-form-group>

            <b-button
              type="submit"
              class="w-100 btn-size akkurate-green-btn mt-2"
              :disabled="loading"
            >
              <b-spinner v-if="loading" small class="me-2" />
              Sign in
            </b-button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import { getLoginErrorMessage } from "@/core/helpers/authErrors";

export default {
  name: "Login",
  data() {
    return {
      form: { email: "", password: "" },
      loading: false,
      showError: false,
      errorMsg: "",
    };
  },
  computed: {
    heroImageSrc() {
      return require("@/assets/img/login.jpg");
    },
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.showError = false;
      try {
        const res = await ApiService.post("auth/login", this.form);
        JwtService.saveToken(res.token);
        this.$store.commit("SET_USER", res.user);
        await this.$store.dispatch("loadSettings");
        this.$router.push({ name: "home" });
      } catch (e) {
        this.errorMsg = getLoginErrorMessage(e);
        this.showError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
